import script from "./OptionChangeConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionChangeConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./OptionChangeConfirmationModal.vue?vue&type=style&index=0&id=1ed75aa0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed75aa0"]])

export default __exports__